import React from "react";

function NewsContainer({ news,search }) {
  if (news !== "" && news.totalRecords !== 0 && news.error !== "Not Found") {
    return (
      <div className="p-5 bg-light pt-2 px-2 px-sm-5">
        <h3>News</h3>
        {news.records.map((data, index) => {
          var link_ref ="https://www.otcmarkets.com/stock/"+search+"/news/story?e&id=" +data.id;
          return (
            <div className=" mb-2" key={index}>
              <a key={index} href={link_ref}  target="_blank" rel="noreferrer" className="text-dark">
                {data.headline}
                <span className="ml-5">{data.formattedPublishedDate}</span>
              </a>
              <hr className="bg-dark"></hr>
            </div>
          );
        })}
      </div>
    );
  } else {
    return "";
  }
}

export default NewsContainer;
